import React, { createRef } from "react";
import ToggleLink from "../../../../dropdown/toggleLink";
import MenuContent from "../../../../dropdown/menuContent";
import { Link } from "react-router-dom";
import SmoothDropdown from "../../../../../../../components/controllers/shared/smoothDropdown/smoothDropdown";
import NoDemoLink from "components/controllers/shared/tooltip/noDemoLink";

const PlanningAndGuidanceDropdown: React.FC = () => {
	let ref = createRef<HTMLUListElement>();

	return (
		<SmoothDropdown id="dropdown-custom-my-accounts">
			<ToggleLink className="myAccountsActivator" bsRole="toggle">
				Planning and guidance
				<i
					className="fa fa-chevron-down util-margin-left-5"
					style={{
						fontSize: "10px",
						marginTop: "-4px",
						verticalAlign: "middle",
					}}
					aria-hidden="true"
				></i>
			</ToggleLink>

			<MenuContent
				additionalClasses="webdemoMyAccountsList"
				bsRole="menu"
			>
				<div
					style={{
						padding: "12px",
						marginTop: "10px",
						fontSize: "14px",
					}}
				>
					TOOLS AND RESOURCES
				</div>
				<ul ref={ref} className="planningAndGuidanceContent">
					<li>
						<Link
							className="myAccountLinks"
							to="/member/individual-dashboard/account-aggregation"
							style={{
								maxHeight: "60px",
								textDecoration: "none",
								lineHeight: 1,
							}}
						>
							Manage your linked accounts
						</Link>
					</li>
					<li>
						<NoDemoLink style={{ width: "100%" }}>
							<Link
								className="myAccountLinks"
								to="#"
								style={{
									maxHeight: "60px",
									textDecoration: "none",
									lineHeight: 1,
								}}
							>
								Review and adjust your budget
							</Link>
						</NoDemoLink>
					</li>
					<li>
						<NoDemoLink>
							<Link
								className="myAccountLinks"
								to="#"
								style={{
									maxHeight: "60px",
									textDecoration: "none",
									lineHeight: 1,
								}}
							>
								Watch on-demand webinars
							</Link>
						</NoDemoLink>
					</li>
					<li>
						<NoDemoLink>
							<Link
								className="myAccountLinks"
								to="#"
								style={{
									maxHeight: "60px",
									textDecoration: "none",
									lineHeight: 1,
								}}
							>
								Learn more about money
							</Link>
						</NoDemoLink>
					</li>
					<li>
						<NoDemoLink>
							<Link
								className="myAccountLinks"
								to="#"
								style={{
									maxHeight: "60px",
									textDecoration: "none",
									lineHeight: 1,
								}}
							>
								Protect your income
							</Link>
						</NoDemoLink>
					</li>
				</ul>
			</MenuContent>
		</SmoothDropdown>
	);
};

export default PlanningAndGuidanceDropdown;
